export default __webpack_public_path__ + "static/media/MercedesBG.869364ca.png";